module.exports = "/lucky-balls/img/drum/drum_loop_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_009.png
// module id = 1024
// module chunks = 0